import { template } from 'lodash'

export enum FeeMethod {
  /**
   * 不收取
   */
  NONE = 0,
  /**
   * 按场次收取
   */
  SESSION = 1,
  /**
   * 按量收取
   */
  QUANTITY = 2,
  /**
   * 按成交额比例收取
   */
  PROPORTIONAL = 3,
  /**
   * 按梯度收取
   */
  GRADIENT = 4
}

export const FeeMethodTextMap: Record<FeeMethod, string> = {
  [FeeMethod.NONE]: '不收取',
  [FeeMethod.SESSION]: '按场次收取',
  [FeeMethod.QUANTITY]: '按数量收取',
  [FeeMethod.PROPORTIONAL]: '按成交额比例收取',
  [FeeMethod.GRADIENT]: '按梯度收取'
}

export const FeeMethodUnitMap: Record<FeeMethod, string> = {
  [FeeMethod.NONE]: '',
  [FeeMethod.SESSION]: '元',
  [FeeMethod.QUANTITY]: '元/吨',
  [FeeMethod.PROPORTIONAL]: '‱',
  [FeeMethod.GRADIENT]: ''
}

export const FeeMethodTemplateMap = {
  [FeeMethod.NONE]: template('无'),
  [FeeMethod.SESSION]: template(
    '整场收取 ${ value } ' + FeeMethodUnitMap[FeeMethod.SESSION]
  ),
  [FeeMethod.QUANTITY]: template(
    '收取 ${ value } ' + FeeMethodUnitMap[FeeMethod.QUANTITY]
  ),
  [FeeMethod.PROPORTIONAL]: template(
    '成交额的 ${ value } ' + FeeMethodUnitMap[FeeMethod.PROPORTIONAL]
  ),
  [FeeMethod.GRADIENT]: template('按梯度收取')
}
